import { SubscriptionStatuses } from '@site-mate/sitemate-global-shared/lib';

export const AccountUpgradeButtonContent = {
  [SubscriptionStatuses.ExpiredTrial]: 'Trial Ended',
  [SubscriptionStatuses.Churned]: 'Reactivate',
  [SubscriptionStatuses.Paused]: 'Resume',
  [SubscriptionStatuses.OverdueInvoice]: 'Overdue invoices',
  [SubscriptionStatuses.FreeTrial]: 'Trial Ended',
};
